import React from 'react'

function CustomerQueries() {
  return (
    <div>
      
    </div>
  )
}

export default CustomerQueries
